<script setup lang="ts">
import type { SessionView } from '@/shared/contracts';
import FfSiteHeader from './components/FfSiteHeader.vue';
defineProps<{ session: SessionView; divisionName: string }>();
</script>
<template><div class="portal-shell shell-ff"><FfSiteHeader :session="session" :division-name="divisionName" /><main id="content" class="workspace"><slot /></main><slot name="mobile" /></div></template>
